<form class="form-b4a">
  <span class="full-w">
    <label for="webhookrec">URL de Webhook das Recorrências</label>
    <p-inputGroup>
      <input
        type="text"
        pInputText
        [formControl]="webhookrec"
        name="webhookrec"
        id="webhookrec"
        (blur)="updateWebhook('webhookrec')"
      />
      <p-inputGroupAddon
        (click)="removeWebhook('webhookrec')"
        *ngIf="webhookrec.valid"
      >
        <i
          class="pi pi-times"
          pRipple
          pTooltip="Remover webhook"
          tooltipPosition="bottom"
        ></i>
      </p-inputGroupAddon>
    </p-inputGroup>
  </span>
  <span class="full-w">
    <label for="webhook">URL de Webhook das Cobranças imediatas</label>
    <p-inputGroup>
      <input
        type="text"
        pInputText
        [formControl]="webhook"
        name="webhook"
        id="webhook"
        (blur)="!wrongSuffix && updateWebhook('webhook')"
      />
      <p-inputGroupAddon
        (click)="removeWebhook('webhook')"
        *ngIf="webhook.valid"
      >
        <i
          class="pi pi-times"
          pRipple
          pTooltip="Remover webhook"
          tooltipPosition="bottom"
        ></i>
      </p-inputGroupAddon>
    </p-inputGroup>
    <small>
      * Todo evento deste webhook será enviado com o sufixo "/pix" na URL
    </small>
    <small>** Não incluir o sufixo "/pix" neste formulário </small>
    <small class="error" *ngIf="wrongSuffix">
      *** O sufixo "/pix" não deve ser incluído neste formulário
    </small>
  </span>
  <span class="full-w">
    <label for="webhookcobr"> URL de Webhook das Cobranças recorrentes </label>
    <p-inputGroup>
      <input
        type="text"
        pInputText
        [formControl]="webhookcobr"
        name="webhookcobr"
        id="webhookcobr"
        (blur)="updateWebhook('webhookcobr')"
      />
      <p-inputGroupAddon
        (click)="removeWebhook('webhookcobr')"
        *ngIf="webhookcobr.valid"
      >
        <i
          class="pi pi-times"
          pRipple
          pTooltip="Remover webhook"
          tooltipPosition="bottom"
        ></i>
      </p-inputGroupAddon>
    </p-inputGroup>
  </span>
</form>
<p-toast />
